import classnames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import { TTool } from '@/_components/promo-zone/_types';
import { BasketImage } from '@/_components/basket-image';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Tool';

export const Tool = ({ name, icon }: TTool) => {
  const translations = useTranslations();

  return (
    <div className={cn(BLOCK_NAME)}>
      <div className={cn(`${BLOCK_NAME}__icon`)}>
        <BasketImage alt="jam-logo" fill sizes="100%" src={icon} />
      </div>
      <span className={cn(`${BLOCK_NAME}__name`)}>{translations(name)}</span>
    </div>
  );
};
